<template>
    <div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <router-link to="/dashboard">Dashboard</router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page"><i class="fas fa-bug"></i> Submit a Bug</li>
            </ol>
        </nav>

        <h4 class="page-header">
            <i class="fas fa-bug"></i> Submit a Bug
        </h4>

        <div class="card">
            <div class="card-body">
                <div class="row mb-4">
                    <div class="col-md-3 col-12 text-md-right" :class="{'text-danger': errors.summary, 'text-muted': !errors.summary}">Summary: <i class="fas fa-sm fa-asterisk text-danger"></i></div>
                    <div class="col-md-6 col-12">
                        <input type="text" v-model="bug.summary" :class="{'form-control': true, 'is-invalid': errors.summary}" placeholder="Enter a Title for your Issue" />

                        <div class="text-danger mt-2" v-if="errors.summary">
                            <ul class="list-unstyled">
                                <li v-for="err in errors.summary">{{ err }}</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="row mb-4">
                    <div class="col-md-3 col-12 text-md-right" :class="{'text-danger': errors.bug_url, 'text-muted': !errors.bug_url}">URL where the issue occurred: <i class="fa fa-sm fa-asterisk text-danger"></i></div>
                    <div class="col-md-6 col-12">
                        <input type="text" v-model="bug.bug_url" :class="{'form-control': true, 'is-invalid': errors.bug_url}" placeholder="Enter URL" />

                        <div class="text-danger mt-2" v-if="errors.bug_url">
                            <ul class="list-unstyled">
                                <li v-for="err in errors.bug_url">{{ err }}</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="row mb-4">
                    <div class="col-md-3 col-12 text-md-right" :class="{'text-danger': errors.bug_description, 'text-muted': !errors.bug_description}">Detailed Description: <i class="fas fa-sm fa-asterisk text-danger"></i></div>
                    <div class="col-md-6 col-12">
                        <b-form-textarea v-model="bug.bug_description" :class="{'is-invalid': errors.bug_description}" placeholder="Enter some details about the issue" rows="4"></b-form-textarea>

                        <div class="text-danger mt-2" v-if="errors.bug_description">
                            <ul class="list-unstyled">
                                <li v-for="err in errors.bug_description">{{ err }}</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="row mb-4" v-if="false">
                    <div class="col-md-3 col-12 text-md-right" :class="{'text-danger': errors.screenshots, 'text-muted': !errors.screenshots}">Screenshots (Optiona):</div>
                    <div class="col-md-6 col-12">
                        <b-form-file v-model="screenshots" :class="{'is-invalid': errors.screenshots}" accept="image/*" placeholder="Select Screenshot(s)"></b-form-file>

                        <div class="text-danger mt-2" v-if="errors.screenshots">
                            <ul class="list-unstyled">
                                <li v-for="err in errors.screenshots">{{ err }}</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-3 col-12 text-md-right text-muted"></div>
                    <div class="col-md-6 col-12">
                        <button type="button" class="btn btn-success" v-on:click="submitBug()" :disabled="saving">
                            <template v-if="saving">
                                <i class="fas fa-spinner fa-spin"></i> Submitting
                            </template v-else>
                            <template>
                                Submit Bug
                            </template>
                        </button>

                        <div class="mt-4 alert alert-success" v-if="successMessage">
                            Ticket#: <strong>{{ successMessage }}</strong>. You will receive an email shortly with the ticket confirmation.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                saving: false,
                successMessage: null,
                user: this.$store.state.user,
                bug: {},
                errors: {},
                screenshots: [],
            }
        },

        computed: {

        },

        methods: {

            submitBug(){
                //Helpers
                this.saving = true;
                this.errors = {};

                //Send it
                this.$http
                .post('/bug', this.bug)
                .then(response => {
                    //Alert the user?
                    this.$toastr.s('Bug Submitted');

                    //Reset the bug
                    this.bug = {};
                    this.files = [];

                    //Set the success message
                    this.successMessage = response.data;

                    //Return to main list?
                    //this.$router.push('/');
                })
                .catch(error => {
                    //Check for error
                    if(error.response && error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data.errors;
                    }
                    else
                    {
                        //Alert the user
                        this.$toastr.e(error.response.data, 'Failed to Submit Bug');
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            }

        },

        mounted() {

        }
    }
</script>
